// extracted by mini-css-extract-plugin
export default {"topMenu":"LanguageToggle_topMenu__1L8R3"};